export enum FILTERS {
  PRIMARY = 'primary',
  ENFORCEMENT = 'enforcement',
  JA = 'ja'
}
